import "entry/common"
import addCSRFTokenToAjaxRequests from "lib/csrfAjaxPrefilter"
import "react_mount_public"
import "react_mount_application"

import LoadMoreController from "controllers/load_more_controller"
import PreferencesCheckboxController from "controllers/newsletters/preferences_checkbox_controller"

// Some forms on these pages, like author registration, send jQuery writes
// for readers with no session, so they need the token up front.
addCSRFTokenToAjaxRequests()

Stimulus.register("load-more", LoadMoreController)
Stimulus.register("newsletters--preferences-checkbox", PreferencesCheckboxController)

// Workaround a font issue on Chrome/Windows.
import "lib/chrome_fonts"

// these are being called from inside ERB views, so it needs global scope for now
window.TC.BasePage = require("pages/base_page").default
window.TC.ArticleFinishedPage = require("pages/article_finished_page").default
window.TC.ChooserView = require("views/chooser_view").default
window.TC.ColumnPage = require("pages/column_page").default
window.TC.EditProfilePage = require("pages/edit_profile_page").default
window.TC.InstitutionPage = require("pages/institution_page").default
window.TC.NewEventPage = require("pages/new_event_page").default
window.TC.NewRegistrationPage = require("pages/new_registration_page").default
window.TC.ProfileCredentialsPage = require("pages/profile_credentials_page").default
window.TC.ProfileInstitutionsPage = require("pages/profile_institutions_page").default
window.TC.SearchPage = require("pages/search_page").default
